import React, { useState, Suspense, lazy } from 'react';
import { Check, X, ChevronDown, ArrowRight, ShieldCheck, BookOpen, Download, Lock, Gift, CalendarCheck, Send, Calculator, Search, Tag, Zap, Clock, Map, UserCheck, Target, MapPin, DollarSign, Calendar, XCircle, TrendingUp, Sparkles, Award, MessageSquare } from 'lucide-react';
import { useCart } from './CartContext';
const ExitUpsellPopup = lazy(() => import('./ExitUpsellPopup').then(m => ({
  default: m.ExitUpsellPopup
})));
export function SalesOffer() {
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  const {
    bump1,
    bump2,
    setBump1,
    setBump2,
    totalPrice,
    getCartUrl
  } = useCart();
  const [showUpsell, setShowUpsell] = useState(false);
  const handleCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Freelance desde Cero (Sin Inglés)',
        content_type: 'product',
        value: totalPrice,
        currency: 'USD'
      });
    }
    // Si no tiene bumps, mostrar popup del 30% OFF
    if (!bump1 && !bump2) {
      e.preventDefault();
      setShowUpsell(true);
    }
    // Si tiene bumps, va directo al checkout via el <a> href
  };
  return <>
      <Suspense fallback={null} data-id="element-303">
        <ExitUpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} currentCartUrl={getCartUrl()} data-id="element-304" />
      </Suspense>

      {/* BLOCK 6 — PRODUCT INTRO */}
      <section className="py-14 md:py-16 px-4 md:px-6 bg-[#faf6f1]" data-id="element-305">
        <div className="max-w-5xl mx-auto animate-hero-fade-in" data-id="element-306">
          <div className="text-center mb-10" data-id="element-307">
            <span className="text-[#c9977e] font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-308">
              Presentando
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#3d2b1f] mb-4" data-id="element-309">
              Freelance Desde Cero <br data-id="element-310" />
              <span className="text-[#b8956a]" data-id="element-311">(Sin Inglés)</span>
            </h2>
            <p className="text-xl text-[#6b5744] max-w-2xl mx-auto" data-id="element-312">
              El mapa completo para entrar al mercado digital hispano de EE.UU.
              sin experiencia previa, sin inglés y sin título universitario.
            </p>
          </div>

          <div className="bg-white p-6 md:p-10 rounded-3xl shadow-lg border border-[#e0bfb4]/30" data-id="element-313">
            <div className="text-center mb-8" data-id="element-314">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#b8956a]/10 mb-4" data-id="element-315">
                <BookOpen className="w-6 h-6 text-[#b8956a]" data-id="element-316" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#3d2b1f] mb-2" data-id="element-317">
                Lo Que Encontrarás Adentro
              </h3>
              <p className="text-[#6b5744] font-medium" data-id="element-318">
                Cada sección fue diseñada para que no solo aprendas — sino que
                ejecutes.
              </p>
            </div>

            <div className="hidden md:grid grid-cols-12 gap-4 pb-4 border-b-2 border-[#e0bfb4]/30 mb-4 px-4" data-id="element-319">
              <div className="col-span-4 font-bold text-[#b8956a] text-sm uppercase tracking-wider" data-id="element-320">
                Sección
              </div>
              <div className="col-span-4 font-bold text-[#b8956a] text-sm uppercase tracking-wider" data-id="element-321">
                Lo que aprendes
              </div>
              <div className="col-span-4 font-bold text-[#b8956a] text-sm uppercase tracking-wider" data-id="element-322">
                Lo que puedes hacer después
              </div>
            </div>

            <div className="space-y-4 md:space-y-2" data-id="element-323">
              {[{
              icon: <Map className="w-5 h-5" data-id="element-324" />,
              sec: 'El Arbitraje de Idioma',
              learn: 'Por qué tu español vale más en el mercado digital',
              do: 'Entender exactamente tu ventaja competitiva'
            }, {
              icon: <UserCheck className="w-5 h-5" data-id="element-325" />,
              sec: 'Los 5 Roles + Test de Rol',
              learn: 'Cuál de los 5 roles es perfecto para TI',
              do: 'Elegir tu rol en 10 minutos con el test incluido'
            }, {
              icon: <Clock className="w-5 h-5" data-id="element-326" />,
              sec: 'Tu Día Tipo Freelance',
              learn: 'Cómo se ve tu vida con 2 clientes activos',
              do: 'Visualizar y planificar tu nueva rutina'
            }, {
              icon: <Target className="w-5 h-5" data-id="element-327" />,
              sec: 'Perfil Magnético',
              learn: 'Cómo presentarte sin inventar experiencia',
              do: 'Tener tu perfil listo para recibir clientes'
            }, {
              icon: <MessageSquare className="w-5 h-5" data-id="element-328" />,
              sec: 'Mensaje de 3 Líneas',
              learn: 'El script exacto para tu primer contacto',
              do: 'Enviar tu primer mensaje hoy mismo'
            }, {
              icon: <MapPin className="w-5 h-5" data-id="element-329" />,
              sec: 'Mapa de Plataformas',
              learn: 'Dónde están los clientes que te buscan',
              do: 'Protocolo de 15 minutos para encontrar clientes'
            }, {
              icon: <DollarSign className="w-5 h-5" data-id="element-330" />,
              sec: 'Guión de Cobro',
              learn: 'Qué decir exactamente para cobrar',
              do: 'Cobrar sin incomodidad desde el primer cliente'
            }, {
              icon: <Calendar className="w-5 h-5" data-id="element-331" />,
              sec: 'Plan Semana a Semana',
              learn: 'Qué hacer cada día de tu primer mes',
              do: 'Tener un plan de acción de 30 días listo'
            }, {
              icon: <XCircle className="w-5 h-5" data-id="element-332" />,
              sec: 'Errores Comunes',
              learn: 'Los errores que frenan a las principiantes',
              do: 'Evitarlos antes de que te cuesten tiempo y dinero'
            }, {
              icon: <TrendingUp className="w-5 h-5" data-id="element-333" />,
              sec: 'Cuándo Subir Precios',
              learn: 'El momento exacto y las palabras exactas',
              do: 'Duplicar tus ingresos sin perder clientes'
            }].map((item, index) => <div key={index} className={`p-4 rounded-2xl md:grid md:grid-cols-12 md:gap-4 md:items-center ${index % 2 === 0 ? 'bg-[#faf6f1]/50' : 'bg-white'}`} data-id="element-334">
                  <div className="col-span-4 flex items-center gap-3 mb-3 md:mb-0" data-id="element-335">
                    <div className="bg-[#b8956a]/10 p-2 rounded-lg text-[#b8956a] flex-shrink-0" data-id="element-336">
                      {item.icon}
                    </div>
                    <span className="font-bold text-[#3d2b1f]" data-id="element-337">{item.sec}</span>
                  </div>
                  <div className="col-span-4 mb-2 md:mb-0" data-id="element-338">
                    <span className="md:hidden text-xs font-bold text-[#b8956a] uppercase block mb-1" data-id="element-339">
                      Lo que aprendes:
                    </span>
                    <span className="text-[#6b5744] text-sm" data-id="element-340">{item.learn}</span>
                  </div>
                  <div className="col-span-4" data-id="element-341">
                    <span className="md:hidden text-xs font-bold text-[#b8956a] uppercase block mb-1" data-id="element-342">
                      Lo que puedes hacer después:
                    </span>
                    <span className="text-[#7a9a6b] font-medium text-sm flex items-start gap-2" data-id="element-343">
                      <Check className="w-4 h-4 flex-shrink-0 mt-0.5" data-id="element-344" />
                      {item.do}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* BLOCK 7.5 — URGENCY MID-PAGE */}
      <section className="py-8 md:py-10 px-4 md:px-6 bg-[#faf6f1] text-center" data-id="element-345">
        <div className="max-w-3xl mx-auto animate-hero-fade-in" data-id="element-346">
          <div className="inline-flex items-center justify-center gap-3 mb-4" data-id="element-347">
            <div className="w-10 h-10 rounded-full bg-[#c47a6a]/10 flex items-center justify-center flex-shrink-0" data-id="element-348">
              <Zap className="w-5 h-5 text-[#c47a6a]" data-id="element-349" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#3d2b1f]" data-id="element-350">
              Mientras Lees Esto...
            </h2>
          </div>

          <div className="space-y-4 text-lg md:text-xl text-[#6b5744] font-medium mb-10" data-id="element-351">
            <p className="text-[#3d2b1f]" data-id="element-352">
              Hay una mujer latina en tu ciudad que acaba de enviar su primer
              mensaje a un negocio con el Método de 3 Líneas de este mapa.
            </p>
            <p data-id="element-353">Mañana va a tener una respuesta.</p>
            <p data-id="element-354">La semana que viene va a tener su primer cliente.</p>
            <p data-id="element-355">El mes que viene va a tener $300-$500 extras.</p>
            <p className="text-[#c47a6a] font-bold" data-id="element-356">
              La única diferencia entre ella y tú en este momento es que ella ya
              hizo clic.
            </p>
            <p className="text-2xl font-bold text-[#b8956a] pt-4" data-id="element-357">
              ¿Cuándo vas a ser tú?
            </p>
          </div>

          {/* Anti-confusion block */}
          <div className="mt-6 max-w-2xl mx-auto bg-[#3d2b1f]/5 border border-[#e0bfb4]/40 rounded-xl p-3 md:p-4" data-id="element-358">
            <p className="text-xs md:text-sm text-[#6b5744] leading-relaxed text-center" data-id="element-359">
              <span className="font-bold text-[#3d2b1f]" data-id="element-360">Importante:</span> esto
              no es una vacante ni una empresa te contrata. Es una guía para que
              tú ofrezcas un servicio (mensajes, citas, chat) a negocios latinos
              y les cobres directo.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCK 12 — MAIN CTA */}
      <section id="offer" className="py-14 md:py-16 px-4 md:px-6 bg-[#faf6f1] text-center relative" data-id="element-361">
        <div className="max-w-3xl mx-auto relative z-10 animate-hero-fade-in" data-id="element-362">
          <div className="bg-[#f5e6e0] p-8 md:p-14 rounded-[2.5rem] border-2 border-[#b8956a] shadow-2xl shadow-[#b8956a]/10 mb-8" data-id="element-363">
            <h3 className="text-3xl md:text-4xl font-bold mb-4 text-[#3d2b1f]" data-id="element-364">
              Accede ahora a <br className="hidden md:block" data-id="element-365" />
              Freelance Desde Cero{' '}
              <span className="text-[#b8956a]" data-id="element-366">(Sin Inglés)</span>
            </h3>

            {/* PRICE BLOCK — FIRST */}

            {/* MAIN CTA BUTTON */}
            <p className="text-center text-sm text-[#6b5744] mb-2" data-id="element-367">
              <span className="font-medium" data-id="element-368">Valor total:</span>{' '}
              <span className="line-through text-[#9a8b7a] font-bold" data-id="element-369">
                $197 USD
              </span>
            </p>
            <a href={getCartUrl()} onClick={handleCTA} className="w-full px-8 py-5 mb-6 bg-[#b8956a] hover:bg-[#c9a87a] text-[#3d2b1f] font-bold rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 group text-[18px]" data-id="element-370">
              Sí, quiero conseguir mi primer cliente — ${totalPrice} USD
            </a>
            <p className="text-center text-xs md:text-sm font-bold text-[#c47a6a] mb-4" data-id="element-371">
              ⚠️ Precio de $14 disponible solo esta semana
            </p>

            {/* ORDER BUMPS */}
            <div className="space-y-4 w-full mb-6" data-id="element-372">
              {/* ORDER BUMP 1 — Scripts de Poder */}
              <div className={`relative bg-white rounded-2xl border-2 border-dashed overflow-hidden order-bump-shimmer transition-all duration-300 ${bump1 ? 'border-[#c9977e] shadow-md shadow-[#c9977e]/20' : 'border-[#b8956a]'}`} onClick={() => setBump1(!bump1)} style={{
              cursor: 'pointer'
            }} data-id="element-373">
                <div className={`px-4 py-2.5 flex items-center gap-2 transition-colors duration-300 ${bump1 ? 'bg-[#c9977e]' : 'bg-[#7a9a6b]'}`} data-id="element-374">
                  <Zap className="w-4 h-4 text-[#3d2b1f]" data-id="element-375" />
                  <span className="font-bold text-[#3d2b1f] text-sm" data-id="element-376">
                    AGREGAR A MI ORDEN
                  </span>
                  {bump1 && <Check className="w-4 h-4 text-white ml-auto" data-id="element-377" />}
                </div>
                <div className="p-5 flex flex-col sm:flex-row gap-4" data-id="element-378">
                  <img src="https://cdn.magicpatterns.com/uploads/5sPr35MLz8XCuTo6H1Mn6z/ORDER_BUMP_1.png" alt="Scripts de Poder - Zero-Draft Template Library" className="w-full sm:w-28 h-auto rounded-xl shadow-md flex-shrink-0 object-cover" width={112} height={112} loading="lazy" decoding="async" data-id="element-379" />
                  <div className="flex-1" data-id="element-380">
                    <div className="flex items-start gap-2 mb-2" data-id="element-381">
                      <div onClick={e => {
                      e.stopPropagation();
                      setBump1(!bump1);
                    }} className={`mt-0.5 w-6 h-6 rounded-md border-2 flex-shrink-0 cursor-pointer flex items-center justify-center transition-all duration-200 ${bump1 ? 'bg-[#7a9a6b] border-[#7a9a6b]' : 'bg-white border-[#7a9a6b] shadow-[0_0_6px_rgba(122,154,107,0.4)]'}`} data-id="element-382">
                        {bump1 && <Check className="w-4 h-4 text-white" data-id="element-383" />}
                      </div>
                      <h4 className="font-bold text-[#3d2b1f] text-base leading-snug" data-id="element-384">
                        SÍ, AGREGAR LOS "SCRIPTS DE PODER"{' '}
                        <span className="text-[#c47a6a]" data-id="element-385">(Solo hoy $9)</span>
                      </h4>
                    </div>
                    <p className="text-[#6b5744] text-sm leading-relaxed" data-id="element-386">
                      No te quedes "en blanco" frente al cliente ni pierdas
                      ventas por no saber qué responder. Agrega la Biblioteca de
                      Plantillas "Zero-Draft" y recibe los guiones exactos de
                      copiar y pegar para cerrar tratos por WhatsApp. Incluye
                      respuestas maestras para cuando te digan: "Está muy caro",
                      "Déjame pensarlo" o "¿Qué experiencia tienes?". Ahórrate
                      el estrés de redactar y suena como una profesional desde
                      el primer minuto.
                    </p>
                  </div>
                </div>
              </div>

              {/* ORDER BUMP 2 — Contrato Relámpago */}
              <div className={`relative bg-white rounded-2xl border-2 border-dashed overflow-hidden order-bump-shimmer transition-all duration-300 ${bump2 ? 'border-[#c9977e] shadow-md shadow-[#c9977e]/20' : 'border-[#b8956a]'}`} onClick={() => setBump2(!bump2)} style={{
              cursor: 'pointer'
            }} data-id="element-387">
                <div className={`px-4 py-2.5 flex items-center gap-2 transition-colors duration-300 ${bump2 ? 'bg-[#c9977e]' : 'bg-[#7a9a6b]'}`} data-id="element-388">
                  <ShieldCheck className="w-4 h-4 text-[#3d2b1f]" data-id="element-389" />
                  <span className="font-bold text-[#3d2b1f] text-sm" data-id="element-390">
                    AGREGAR A MI ORDEN
                  </span>
                  {bump2 && <Check className="w-4 h-4 text-white ml-auto" data-id="element-391" />}
                </div>
                <div className="p-5 flex flex-col sm:flex-row gap-4" data-id="element-392">
                  <img src="https://cdn.magicpatterns.com/uploads/sSziKsEkdfvwWrA5CnapFd/ORDER_BUMP_2.png" alt="El Contrato Relámpago - Acuerdo de Retención Pro" className="w-full sm:w-28 h-auto rounded-xl shadow-md flex-shrink-0 object-cover" width={112} height={112} loading="lazy" decoding="async" data-id="element-393" />
                  <div className="flex-1" data-id="element-394">
                    <div className="flex items-start gap-2 mb-2" data-id="element-395">
                      <div onClick={e => {
                      e.stopPropagation();
                      setBump2(!bump2);
                    }} className={`mt-0.5 w-6 h-6 rounded-md border-2 flex-shrink-0 cursor-pointer flex items-center justify-center transition-all duration-200 ${bump2 ? 'bg-[#7a9a6b] border-[#7a9a6b]' : 'bg-white border-[#7a9a6b] shadow-[0_0_6px_rgba(122,154,107,0.4)]'}`} data-id="element-396">
                        {bump2 && <Check className="w-4 h-4 text-white" data-id="element-397" />}
                      </div>
                      <h4 className="font-bold text-[#3d2b1f] text-base leading-snug" data-id="element-398">
                        SÍ, QUIERO EL "CONTRATO RELÁMPAGO"{' '}
                        <span className="text-[#c47a6a]" data-id="element-399">(Solo hoy $9)</span>
                      </h4>
                    </div>
                    <p className="text-[#6b5744] text-sm leading-relaxed" data-id="element-400">
                      Protege tu tiempo y asegura tus pagos sin necesidad de
                      abogados. Agrega el Acuerdo de Retención Pro y formaliza
                      tu negocio en segundos. Este contrato de una sola página
                      pone límites claros: define tus horarios, asegura que te
                      paguen por adelantado y evita que los clientes te pidan
                      "favores extra" gratis. Trabaja con la tranquilidad de que
                      tu esfuerzo está respaldado legalmente.{' '}
                      <span className="font-medium text-[#9a8b7a]" data-id="element-401">
                        (Valor real: $47)
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ORDER SUMMARY */}
            <div className="bg-[#3d2b1f] rounded-2xl p-5 md:p-6 text-left mb-6" data-id="element-402">
              <p className="text-center text-sm font-bold text-[#d4b896] uppercase tracking-wider mb-4" data-id="element-403">
                Resumen de tu orden
              </p>
              <div className="space-y-2.5" data-id="element-404">
                {/* Base product - always included */}
                <div className="flex items-center justify-between" data-id="element-405">
                  <div className="flex items-center gap-2" data-id="element-406">
                    <Check className="w-4 h-4 text-[#7a9a6b] flex-shrink-0" data-id="element-407" />
                    <span className="text-[#faf6f1] text-sm font-medium" data-id="element-408">
                      Freelance Desde Cero (Sin Inglés) + 5 Bonos
                    </span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-409">
                    <span className="text-[#b8956a] font-bold text-sm" data-id="element-410">
                      $14
                    </span>
                  </div>
                </div>

                {/* Bump 1 */}
                <div className={`flex items-center justify-between transition-opacity duration-300 ${bump1 ? 'opacity-100' : 'opacity-40'}`} data-id="element-411">
                  <div className="flex items-center gap-2" data-id="element-412">
                    {bump1 ? <Check className="w-4 h-4 text-[#7a9a6b] flex-shrink-0" data-id="element-413" /> : <X className="w-4 h-4 text-[#9a8b7a] flex-shrink-0" data-id="element-414" />}
                    <span className={`text-sm ${bump1 ? 'text-[#faf6f1] font-medium' : 'text-[#9a8b7a]'}`} data-id="element-415">
                      Scripts de Poder (Zero-Draft)
                    </span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-416">
                    <span className="text-[#9a8b7a] line-through text-xs" data-id="element-417">
                      $47
                    </span>
                    <span className={`font-bold text-sm ${bump1 ? 'text-[#b8956a]' : 'text-[#9a8b7a]'}`} data-id="element-418">
                      {bump1 ? '$9' : '—'}
                    </span>
                  </div>
                </div>

                {/* Bump 2 */}
                <div className={`flex items-center justify-between transition-opacity duration-300 ${bump2 ? 'opacity-100' : 'opacity-40'}`} data-id="element-419">
                  <div className="flex items-center gap-2" data-id="element-420">
                    {bump2 ? <Check className="w-4 h-4 text-[#7a9a6b] flex-shrink-0" data-id="element-421" /> : <X className="w-4 h-4 text-[#9a8b7a] flex-shrink-0" data-id="element-422" />}
                    <span className={`text-sm ${bump2 ? 'text-[#faf6f1] font-medium' : 'text-[#9a8b7a]'}`} data-id="element-423">
                      Contrato Relámpago
                    </span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-424">
                    <span className="text-[#9a8b7a] line-through text-xs" data-id="element-425">
                      $47
                    </span>
                    <span className={`font-bold text-sm ${bump2 ? 'text-[#b8956a]' : 'text-[#9a8b7a]'}`} data-id="element-426">
                      {bump2 ? '$9' : '—'}
                    </span>
                  </div>
                </div>

                {/* Divider */}
                <div className="border-t border-[#6b5744]/40 my-3" data-id="element-427"></div>

                {/* Totals */}
                <div className="flex items-center justify-between" data-id="element-428">
                  <span className="text-[#d4b896] text-sm font-bold" data-id="element-429">
                    Precio de lanzamiento:
                  </span>
                  <span className="text-[#b8956a] font-extrabold text-2xl" data-id="element-430">
                    ${totalPrice} USD
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-431">
                  <span className="text-[#9a8b7a] text-sm" data-id="element-432">
                    Precio regular:
                  </span>
                  <span className="text-[#9a8b7a] text-sm" data-id="element-433">$47 USD</span>
                </div>
              </div>
            </div>

            {/* VALUE STACK — NOW BELOW CTA */}
            <div className="mb-8 text-left" data-id="element-434">
              <p className="text-center text-lg font-bold text-[#3d2b1f] mb-5" data-id="element-435">
                Todo lo que recibes hoy:
              </p>
              <div className="space-y-2" data-id="element-436">
                <div className="flex items-center justify-between bg-white/60 rounded-xl px-4 py-3 border border-[#e0bfb4]/40" data-id="element-437">
                  <div className="flex items-center gap-3 flex-1" data-id="element-438">
                    <BookOpen className="w-5 h-5 text-[#b8956a] flex-shrink-0" data-id="element-439" />
                    <span className="font-bold text-[#3d2b1f] text-sm" data-id="element-440">
                      Freelance Desde Cero (Sin Ingles)
                    </span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-441">
                    <span className="text-[#9a8b7a] text-xs" data-id="element-442">Valor $47</span>
                    <span className="text-[#7a9a6b] font-bold text-xs" data-id="element-443">
                      INCLUIDO
                    </span>
                  </div>
                </div>
                {[{
                num: '#1',
                name: 'El Plan 7 Dias "Primer Dinero"',
                val: '$17'
              }, {
                num: '#2',
                name: '50 Mensajes "Copia y Pega"',
                val: '$17'
              }, {
                num: '#3',
                name: 'Calculadora Express de Precios',
                val: '$9'
              }, {
                num: '#4',
                name: 'La Lista Secreta: 50 Negocios',
                val: '$17'
              }, {
                num: '#5',
                name: 'Tabla de Precios Inteligente',
                val: '$9'
              }, {
                num: '#6',
                name: 'Kit Credibilidad Instantanea',
                val: '$27',
                nuevo: true
              }].map((b, i) => <div key={i} className={`flex items-center justify-between rounded-xl px-4 py-3 border relative ${b.nuevo ? 'bg-gradient-to-r from-[#b8956a]/10 to-[#c47a6a]/10 border-2 border-[#c47a6a]/40' : 'bg-white/60 border-[#e0bfb4]/40'}`} data-id="element-444">
                    {b.nuevo && <span className="absolute -top-2 left-3 bg-[#c47a6a] text-white text-[8px] font-bold px-2 py-0.5 rounded-full tracking-wider uppercase flex items-center gap-1" data-id="element-445">
                        <Sparkles className="w-2.5 h-2.5" data-id="element-446" />
                        NUEVO
                      </span>}
                    <div className="flex items-center gap-3 flex-1" data-id="element-447">
                      <Gift className={`w-5 h-5 flex-shrink-0 ${b.nuevo ? 'text-[#c47a6a]' : 'text-[#b8956a]'}`} data-id="element-448" />
                      <div data-id="element-449">
                        <span className="font-bold text-[#3d2b1f] text-sm" data-id="element-450">
                          BONO {b.num}
                        </span>
                        <span className="text-[#6b5744] text-sm" data-id="element-451">
                          {' '}
                          — {b.name}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0" data-id="element-452">
                      <span className="text-[#9a8b7a] text-xs" data-id="element-453">
                        Valor {b.val}
                      </span>
                      <span className="text-[#7a9a6b] font-bold text-xs" data-id="element-454">
                        INCLUIDO
                      </span>
                    </div>
                  </div>)}
              </div>

              {/* Leer más toggle */}
              <button onClick={() => setShowBonusDetails(!showBonusDetails)} className="flex items-center justify-center gap-2 mx-auto mt-4 text-[#b8956a] font-bold text-sm hover:text-[#c9a87a] transition-colors" data-id="element-455">
                {showBonusDetails ? 'Ver menos' : 'Leer más sobre los bonos'}
                <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${showBonusDetails ? 'rotate-180' : ''}`} data-id="element-456" />
              </button>

              {showBonusDetails && <div className="mt-6 space-y-6 animate-hero-fade-in" data-id="element-457">
                  {/* BONO 1 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border border-[#e0bfb4]/40" data-id="element-458">
                    <div className="flex flex-col sm:flex-row gap-4" data-id="element-459">
                      <img src="https://cdn.magicpatterns.com/uploads/tj4w3dzjdE8gLhXHBdBFWk/BONO_1.png" alt="Bono 1" className="w-24 h-auto rounded-lg shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-460" />
                      <div data-id="element-461">
                        <div className="flex items-center gap-2 mb-2" data-id="element-462">
                          <Gift className="w-4 h-4 text-[#b8956a]" data-id="element-463" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-464">
                            BONO #1
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-465">
                          EL PLAN 7 DÍAS "PRIMER DINERO" (SIN INGLÉS)
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-466">
                          Un plan día a día (10–20 min/día) para que en 7 días
                          tengas:
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-467">
                          {['20–50 negocios contactados', 'Conversaciones activas reales', 'Mínimo 1 propuesta enviada'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-[#3d2b1f]" data-id="element-468">
                              <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0" data-id="element-469" />
                              <span data-id="element-470">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-xs text-[#6b5744]" data-id="element-471">
                          Incluye: Plan acción Día 1 al Día 7 con checklist
                          diaria, scripts para DM, WhatsApp y Facebook,
                          seguimientos que no molestan, y tracker de control.
                        </p>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-472">
                          "Ya no tendrás excusa de 'no sé por dónde empezar.'"
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* BONO 2 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border border-[#e0bfb4]/40" data-id="element-473">
                    <div className="flex flex-col sm:flex-row gap-4" data-id="element-474">
                      <img src="https://cdn.magicpatterns.com/uploads/tiRmjyzmVTm5Ais22gdmbP/BONO_2.png" alt="Bono 2" className="w-24 h-auto rounded-lg shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-475" />
                      <div data-id="element-476">
                        <div className="flex items-center gap-2 mb-2" data-id="element-477">
                          <Gift className="w-4 h-4 text-[#b8956a]" data-id="element-478" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-479">
                            BONO #2
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-480">
                          50 MENSAJES "COPIA Y PEGA" PARA CONSEGUIR CLIENTES EN
                          ESPAÑOL
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-481">
                          50 mensajes listos para enviar HOY por IG, WhatsApp y
                          Facebook.
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-482">
                          {['15 scripts para Instagram DM', '15 scripts para WhatsApp', '10 scripts para Facebook Page', 'Scripts por industria (Beauty, Dental, Seguros, Restaurantes)', '5 seguimientos que no se sienten intensos', '8 respuestas a objeciones'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#3d2b1f]" data-id="element-483">
                              <Check className="w-4 h-4 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-484" />
                              <span data-id="element-485">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-486">
                          "Solo cambiás el nombre y enviás. Así de simple."
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* BONO 3 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border border-[#e0bfb4]/40" data-id="element-487">
                    <div className="flex flex-col sm:flex-row gap-4" data-id="element-488">
                      <img src="https://cdn.magicpatterns.com/uploads/e5tvQA8W7xvbVBQ4GrAQ3i/BONO_3.png" alt="Bono 3 - Calculadora Express de Precios + Paquetes" className="w-full max-w-[200px] h-auto rounded-xl shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-489" />
                      <div data-id="element-490">
                        <div className="flex items-center gap-2 mb-2" data-id="element-491">
                          <Gift className="w-4 h-4 text-[#b8956a]" data-id="element-492" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-493">
                            BONO #3
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-494">
                          CALCULADORA EXPRESS DE PRECIOS + PAQUETES (PARA COBRAR
                          SIN PENA)
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-495">
                          En 10 minutos tendrás:
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-496">
                          {['Tu precio base calculado (fórmula de 3 pasos)', '3 paquetes listos (Básico / Estándar / Premium)', 'Scripts para enviar tu precio por WhatsApp sin nervios', 'Respuestas a "está caro" y "dame descuento"', 'Checklist para detectar clientes problemáticos antes de empezar', 'Mini acuerdo por WhatsApp (sin contratos ni abogados)'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#3d2b1f]" data-id="element-497">
                              <Check className="w-4 h-4 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-498" />
                              <span data-id="element-499">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-500">
                          "Porque si no sabés cuánto cobrar, terminás aceptando
                          cualquier cosa."
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* BONO 4 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border border-[#e0bfb4]/40" data-id="element-501">
                    <div className="flex flex-col sm:flex-row gap-4" data-id="element-502">
                      <img src="https://cdn.magicpatterns.com/uploads/fnGJQCMUkiEYeP2MZX7c4R/BONO_4.png" alt="Bono 4 - La Lista Secreta" className="w-full max-w-[200px] h-auto rounded-xl shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-503" />
                      <div data-id="element-504">
                        <div className="flex items-center gap-2 mb-2" data-id="element-505">
                          <Gift className="w-4 h-4 text-[#b8956a]" data-id="element-506" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-507">
                            BONO #4
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-508">
                          LA LISTA SECRETA: 50 NEGOCIOS "CHAT-DEPENDIENTES"
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-509">
                          Los 50 tipos de negocios latinos que están perdiendo
                          ventas porque no tienen a nadie que responda sus
                          mensajes.
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-510">
                          {['50 tipos de negocios que necesitan atención por chat', 'Checklist "Señales de Oro" para identificar targets en 10 seg', '3 rutas de búsqueda (IG / Google Maps / Facebook)', '12 aperturas ultra cortas para iniciar conversación', 'Plantilla "Mi Lista de 10" para tus primeros targets'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#3d2b1f]" data-id="element-511">
                              <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-512" />
                              <span data-id="element-513">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-514">
                          "No más parálisis. Solo acción."
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* BONO 5 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border border-[#e0bfb4]/40" data-id="element-515">
                    <div className="flex flex-col sm:flex-row gap-4" data-id="element-516">
                      <img src="https://cdn.magicpatterns.com/uploads/1EEgK2Hnb9QqUyJuP6dcjs/BONO_5.png" alt="Bono 5" className="w-24 h-auto rounded-lg shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-517" />
                      <div data-id="element-518">
                        <div className="flex items-center gap-2 mb-2" data-id="element-519">
                          <Gift className="w-4 h-4 text-[#b8956a]" data-id="element-520" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-521">
                            BONO #5
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-522">
                          TABLA DE PRECIOS INTELIGENTE + 7 PAQUETES LISTOS
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-523">
                          Paquetes claros para que el cliente diga "¿A o B?" en
                          vez de "¿cuánto cobras?"
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-524">
                          {['7 paquetes listos para copiar y mandar por WhatsApp', 'Tabla de Rangos para saber cuánto cobrar según el negocio', 'Guion "A o B" para presentar tu precio con confianza', 'Cláusulas suaves para proteger tu tiempo', 'Mensaje de upgrade para subir tu precio sin fricciones'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#3d2b1f]" data-id="element-525">
                              <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-526" />
                              <span data-id="element-527">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-528">
                          "Así se cobra con seguridad."
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* BONO 6 Detail */}
                  <div className="bg-white/70 rounded-2xl p-5 border-2 border-[#c47a6a]/30 relative" data-id="element-529">
                    <div className="absolute -top-3 left-5 bg-[#c47a6a] text-white text-[10px] font-bold px-3 py-1 rounded-full tracking-wider uppercase flex items-center gap-1.5" data-id="element-530">
                      <Sparkles className="w-3 h-3" data-id="element-531" />
                      NUEVO
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4 mt-2" data-id="element-532">
                      <img src="https://cdn.magicpatterns.com/uploads/iYESVLZkyn6toFX4uygctn/BONO_NUEVO.png" alt="Bono 6 - Kit Credibilidad Instantánea" className="w-24 h-auto rounded-lg shadow-md flex-shrink-0 mx-auto sm:mx-0" loading="lazy" decoding="async" data-id="element-533" />
                      <div data-id="element-534">
                        <div className="flex items-center gap-2 mb-2" data-id="element-535">
                          <Award className="w-4 h-4 text-[#b8956a]" data-id="element-536" />
                          <span className="text-xs font-bold text-[#c9977e] uppercase" data-id="element-537">
                            BONO #6 — NUEVO
                          </span>
                        </div>
                        <h4 className="font-bold text-[#3d2b1f] mb-2" data-id="element-538">
                          KIT "CREDIBILIDAD INSTANTÁNEA" — PORTAFOLIO + MUESTRAS
                          LISTAS (SIN EXPERIENCIA)
                        </h4>
                        <p className="text-[#6b5744] text-sm mb-3" data-id="element-539">
                          Todo lo que necesitas para responder cuando el negocio
                          pregunta "¿qué experiencia tienes?"
                        </p>
                        <ul className="space-y-1 mb-3" data-id="element-540">
                          {['Portafolio de 1 página listo para enviar', 'One-Pager de servicio por cada rol', 'Muestras de trabajo reales para los 5 roles', 'Sistema R-C-C-C para responder con orden', 'Onboarding completo para cuando digan "sí"', '25+ respuestas a preguntas difíciles', 'Plan de acción de hoy (5 pasos en orden)'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#3d2b1f]" data-id="element-541">
                              <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-542" />
                              <span data-id="element-543">{item}</span>
                            </li>)}
                        </ul>
                        <p className="text-[#c9977e] italic text-sm mt-2" data-id="element-544">
                          "Con este kit llegué preparada y el negocio me dijo
                          que se veía muy profesional."
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>

            {/* Urgency line */}
            <p className="mt-6 mb-4 text-center text-sm md:text-base font-bold text-[#c47a6a]" data-id="element-545">
              ⚠️ Precio de $14 disponible solo esta semana
            </p>

            {/* SECOND CTA */}
            <a href={getCartUrl()} onClick={handleCTA} className="w-full px-8 py-5 bg-[#b8956a] hover:bg-[#c9a87a] text-[#3d2b1f] font-bold text-xl rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 group" data-id="element-546">
              Sí, quiero acceso inmediato — ${totalPrice} USD
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-547" />
            </a>

            <div className="mt-3 flex items-center justify-center gap-2 text-xs text-[#6b5744] font-medium" data-id="element-548">
              <Lock className="w-3.5 h-3.5 flex-shrink-0" data-id="element-549" />
              <span data-id="element-550">
                Pago seguro · Acceso inmediato · Garantía 7 días · 100% en
                español
              </span>
            </div>

            <p className="mt-4 text-lg font-bold text-[#c9977e]" data-id="element-551">
              Tu primer cliente en español te está esperando.
            </p>
          </div>
        </div>
      </section>
    </>;
}